import { Link as DSLink, Span } from "@icg360/design-system";

import { usePolicyDetail } from "data/ss-data-hooks";
import { type Policy } from "data/keystone-api-mapping";
import SettingsPolicy from "pages/settings/common/settings-policy";
import { formatDate } from "utils";

import UnlinkPolicy from "../unlink-policy";
import styles from "./policy-item.module.scss";

type PolicyItemProps = {
  hasMultiplePolicies: boolean;
  policy: Policy;
};

const PolicyItem = ({ hasMultiplePolicies, policy }: PolicyItemProps) => {
  const { policyId, policyState, propertyAddress, isCommercial } = policy;
  const { data, isLoading } = usePolicyDetail(policyId);

  const { expirationDate, effectiveDatePolicyTerm } =
    data?.userDetails?.currentTerm ?? {};

  let policyStatus;
  if (policyState !== undefined) {
    if (RegExp(/(^active)/gi).test(policyState ?? "")) {
      policyStatus = <Span className={styles.activeStatusDS}>Active</Span>;
    } else if (RegExp(/(^nonrenewed)/gi).test(policyState ?? "")) {
      policyStatus = (
        <Span className={styles.inactiveStatusDS}>Non-renewed</Span>
      );
    } else {
      policyStatus = <Span className={styles.inactiveStatusDS}>Cancelled</Span>;
    }
  }

  const detailItems = !isLoading
    ? [
        {
          label: "Policy number:",
          value: (
            <>
              {policyId}{" "}
              <DSLink
                href={`/my/overview?policyId=${policy.insightPolicyId}`}
                className={styles.viewPolicyLink}
              >
                View policy
              </DSLink>
            </>
          ),
        },
        {
          label: "Status:",
          value: policyStatus,
        },
        {
          label: "Policy term:",
          value: `${formatDate(effectiveDatePolicyTerm)} - ${formatDate(
            expirationDate
          )}`,
        },
      ]
    : [];

  return (
    <>
      <SettingsPolicy
        isCommercial={!!isCommercial}
        detailItems={detailItems}
        address={propertyAddress}
        loading={isLoading}
      >
        {hasMultiplePolicies && <UnlinkPolicy policy={policy} />}
      </SettingsPolicy>
    </>
  );
};

export default PolicyItem;
